import { ErrorResponse } from '@src/interface/api/response.interface'
import { signin, SigninResponse } from '@src/lib/api/auth/signin'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

const useSigninQuery = (): UseMutationResult<
	SigninResponse,
	AxiosError<ErrorResponse>,
	{ username: string; password: string }
> => {
	return useMutation(({ username, password }) => signin(username, password))
}
export default useSigninQuery
